import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { siteMetadata } from './siteMetadata';
import { stringifyWebpageSchema } from './sdWebsite';
import { stringifyEventSchema } from './sdEvent';
import { stringifyNewsSchema } from './sdNews';
export const getStructuredDataSchemas = ({ title, pathname, description, nofollow, noindex, image, events, news, }) => {
    const { title: defaultTitle, description: defaultDescription, image: defaultImage, siteUrl, nofollow: defaultNofollow, noindex: defaultNoindex, } = siteMetadata();
    const metadata = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        nofollow: nofollow || defaultNofollow,
        noindex: noindex || defaultNoindex,
        image: image || defaultImage,
        url: pathname || siteUrl || '',
        lang: 'en',
        events: events,
        news: news,
    };
    const schemas = [];
    if (pathname !== '') {
        schemas.push(stringifyWebpageSchema({
            name: metadata === null || metadata === void 0 ? void 0 : metadata.title,
            description: metadata === null || metadata === void 0 ? void 0 : metadata.description,
            url: metadata === null || metadata === void 0 ? void 0 : metadata.url,
            lang: metadata === null || metadata === void 0 ? void 0 : metadata.lang,
        }));
        events === null || events === void 0 ? void 0 : events.map((event) => {
            var _a, _b, _c;
            schemas.push(stringifyEventSchema({
                title: event === null || event === void 0 ? void 0 : event.title,
                description: event === null || event === void 0 ? void 0 : event.shortDescription,
                image: (_a = event === null || event === void 0 ? void 0 : event.representationalImage) === null || _a === void 0 ? void 0 : _a.url,
                url: event === null || event === void 0 ? void 0 : event.slug,
                startDate: event === null || event === void 0 ? void 0 : event.startDate,
                endDate: event === null || event === void 0 ? void 0 : event.endDate,
                eventLocation: (_b = event === null || event === void 0 ? void 0 : event.location) === null || _b === void 0 ? void 0 : _b.address,
                eventLocationName: (_c = event === null || event === void 0 ? void 0 : event.locationText) === null || _c === void 0 ? void 0 : _c.name,
                siteUrl: siteUrl,
            }));
        });
        news === null || news === void 0 ? void 0 : news.map((article) => {
            var _a, _b, _c;
            schemas.push(stringifyNewsSchema({
                title: article === null || article === void 0 ? void 0 : article.title,
                abstract: (_b = (_a = article === null || article === void 0 ? void 0 : article.shortDescription) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.shortDescription,
                author: article === null || article === void 0 ? void 0 : article.author,
                image: (_c = article === null || article === void 0 ? void 0 : article.image) === null || _c === void 0 ? void 0 : _c.url,
                url: article === null || article === void 0 ? void 0 : article.slug,
                publishedDate: article === null || article === void 0 ? void 0 : article.publishedDate,
                siteUrl: siteUrl,
            }));
        });
    }
    return schemas;
};
export const StructuredData = (props) => {
    const schemas = getStructuredDataSchemas(props);
    return (_jsx(_Fragment, { children: schemas.map((schema, index) => (_jsx("script", Object.assign({ type: "application/ld+json" }, { children: schema }), index))) }));
};
export default StructuredData;
